<template>
  <div v-if="store.contentData" class="overallpage">
    <a class="next-link close_link" v-on:click="goBack()">X</a>
    <h2 id="datenschutz">{{getContentData('datenschutz').headline}}</h2>
    <span v-html="getContentData('datenschutz').pageContent"></span>
    <h2 id="agb">{{getContentData('agb').headline}}</h2>
    <span v-html="getContentData('agb').pageContent"></span>
    <h2 id="impressum">{{getContentData('impressum').headline}}</h2>
    <span v-html="getContentData('impressum').pageContent"></span>
  </div>
</template>

<script>
import store from '@/store/store.js';

export default {
  name: 'Delivery',
  components: {
  },
  data() {
    return {
      store,
    };
  },
  mounted: function()
  {
    setTimeout(() => this.scrollFix(this.$route.hash), 500);
  },
  methods: {
    getContentData: function (dataHandle) {
      var contentModel = null;
      for(var i = 0; i < this.store.contentData.length; i++){
        if(this.store.contentData[i].pageHandle == dataHandle){
          contentModel = this.store.contentData[i];
        }
      }
      return contentModel;
    },
    scrollFix: function(hashbang)
    {
      var element = document.getElementById(hashbang.split("#")[1]);
      window.scroll({
      behavior: 'smooth',
      left: 0,
      top: element.offsetTop - 80
    });
    },
    goBack: function(){
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
  
</style>
